import React from 'react';
import GuestAgent from './GuestAgent';
import './CashewAI.css';

const CashewAI: React.FC = () => {

  return (
    <section className="cashew-ai-section cashew-ai-font py-5">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-4 d-flex flex-column align-items-center justify-content-start position-relative mb-4">
            <img src="/images/cashew1.jpg" alt="Cashew the Dog" className="cashew-profile-pic img-fluid" />
            <p className="telegram-link mt-3 text-center">
              You can also reach me on Telegram at <a href="https://t.me/CashewAI_bot" target="_blank" rel="noopener noreferrer">@CashewAI_bot</a>
            </p>
          </div>
          <div className="col-md-8">
            <GuestAgent />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CashewAI;